import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { FETCH_CLIENT, FETCH_CLIENT_SUCCESS, FETCH_CLIENT_FAILURE } from 'src/redux/clientReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchClientFlow(action: { payload: string }): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const clientId = action.payload
    const endpoint = `/dealers_api/clients/${clientId}`
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {}
    })
    yield put(FETCH_CLIENT_SUCCESS(response))
  } catch (error) {
    yield put(FETCH_CLIENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchClientSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_CLIENT, FetchClientFlow)
}
